module.exports = __webpack_public_path__ + "static/media/eusko_jaurlaritza.1b70554e.png";